import { Box } from '@mui/material';
import logo_src from "../../assets/logo.svg";

/**
 * Logo component - accredo logo with standard sizing
 * 
 * Sizes:
 * - small: 60px (for headers, mobile)
 * - medium: 100px (default, for login pages)
 * - large: 150px (for landing pages)
 * 
 * @param {object} props
 * @param {'small'|'medium'|'large'} props.size - Logo size
 * @param {boolean} props.center - Center the logo (default: false)
 * @param {object} props.sx - Additional MUI sx styles
 */
export default function Logo
({
    size = 'medium',
    center = false,
    sx = {},
    ...props
})
{
    const sizeMap = {
        small: '60px',
        medium: '100px',
        large: '150px'
    };

    return (
        <Box
            sx={{
                display: center ? 'flex' : 'inline-flex',
                justifyContent: center ? 'center' : 'flex-start',
                alignItems: 'center',
                ...sx
            }}
            {...props}
        >
            <img 
                src={logo_src} 
                alt="accredo Logo"
                style={{ 
                    width: sizeMap[size],
                    height: 'auto',
                    display: 'block'
                }}
            />
        </Box>
    );
}
